import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Box,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TokenPayload } from "../../models/IToken";
import TokenService from "../../services/token.service";
import { environment } from "../../environment/environment";

const SessionJoinDialog: React.FC = () => {
  const { token } = useParams();

  const getIsRemoteMeetingFlag = () => {
    if (token) {
      let parsedToken: TokenPayload = TokenService.parseToken(false, token);
      let participantDetails = JSON.parse(parsedToken.metadata);
      return participantDetails.isRemoteAccessSession;
    }
  };

  const getDownloadLink = () => {
    const userAgent = window.navigator.userAgent;
    const baseUrl = environment.adminPortalUrl.split("/join")[0];

    if (userAgent.indexOf("Win") !== -1) {
      return `${baseUrl}/downloads/Huddle%20Setup%20${environment.huddleClientVersion}.exe`;
    } else if (userAgent.indexOf("Mac") !== -1) {
      return `${baseUrl}/downloads/Huddle-macOS-installer.zip`;
    } else if (userAgent.indexOf("Linux") !== -1) {
      return `${baseUrl}/downloads/huddle.zip`;
    } else {
      return environment.adminPortalUrl;
    }
  };
  useEffect(() => {
    if (token) {
      getIsRemoteMeetingFlag();
      localStorage.setItem("token", token);
    }
  }, []);
  const navigateToSession = useNavigate();

  const [dialogState, setDialogState] = useState(true);
  const [appLaunched, setAppLaunched] = useState(false);

  const handleBrowser = () => {
    if (localStorage.getItem("token")) {
      setDialogState(false);
      navigateToSession("/session");
    }
  };
  const handleHuddleAgent = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      return;
    }

    setAppLaunched(true);
    window.location.href = `huddleaccops://?token=${token}`;
  };
  return (
    <>
      {dialogState && (
        <div>
          <Dialog
            open={dialogState}
            keepMounted
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {appLaunched ? (
                  <Box sx={{ py: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: 'text.primary', fontSize: '1.1rem' }}>
                      Please switch to the Huddle application window to continue.
                    </Typography>
                    
                    <Box sx={{ 
                      bgcolor: '#f0f7ff', 
                      p: 2, 
                      borderRadius: 1.5, 
                      border: '1px solid #d0e3ff',
                      mb: 2
                    }}>
                      <Typography variant="subtitle2" sx={{ 
                        fontWeight: 'bold', 
                        mb: 1, 
                        color: '#0056b3',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <InfoOutlinedIcon sx={{ mr: 1, fontSize: 18 }} />
                        If the meeting window did not open automatically:
                      </Typography>
                      <ul style={{ paddingLeft: "20px", margin: 0, color: '#444', fontSize: '0.85rem' }}>
                        <li style={{ marginBottom: '4px' }}>Verify that the Huddle desktop client is installed</li>
                        <li>Check the taskbar, dock, or system tray for an existing Huddle application window</li>
                      </ul>
                    </Box>
                    
                    <Typography variant="body2" sx={{ color: '#666' }}>
                      Click <a href={getDownloadLink()} style={{ color: '#1976d2', fontWeight: 600, textDecoration: 'none' }}>Huddle Desktop Client (v{environment.huddleClientVersion})</a> to download and install the application, then try joining the session again.
                    </Typography>
                  </Box>
                ) : (
                  <>
                    <b>
                      Would you like to continue in your browser or launch the
                      desktop app for a seamless experience?
                    </b>
                    {getIsRemoteMeetingFlag() && (
                      <Box sx={{ 
                        bgcolor: '#fff5f5', 
                        p: 1.5, 
                        borderRadius: 1, 
                        borderLeft: '4px solid #ff0000',
                        mt: 2 
                      }}>
                        <Typography variant="body2" sx={{ color: '#c53030' }}>
                          <b style={{ color: '#ff0000' }}>Note:</b> Remote control
                          of your shared screen is only available when you join
                          using the Huddle Desktop Client app. If you join through
                          a browser, other participants will not be able to
                          remotely control your screen.
                        </Typography>
                      </Box>
                    )}
                  </>
                )}
              </DialogContentText>
            </DialogContent>
            {!appLaunched && (
              <DialogActions>
                <div className="launchDesktopBtn">
                  <Button
                    style={{ marginRight: "10px" }}
                    variant="outlined"
                    onClick={handleBrowser}
                  >
                    Continue in Browser
                  </Button>
                  <Button variant="contained" onClick={handleHuddleAgent}>
                    Launch Desktop App
                  </Button>
                </div>
              </DialogActions>
            )}
          </Dialog>
        </div>
      )}
    </>
  );
};
export default SessionJoinDialog;
